import { exists } from '@/api'
import dayjs from 'dayjs'

export interface BatchReminderListConditionListItem {
  returnPlansDateFrom: string
  returnPlansDateTo: string
  dunningDateFrom: string
  dunningDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  radioBranchType: string
  radioUserType: string
  userType: string
  update: string
  isSearchBooks: boolean
  isSearchAV: boolean
  isSearchMagazine: boolean
  isEnabledHoldingBooks: boolean
  bookCount: string
  isRsvCollection: boolean
  rsvCollectionCount: string
  reminderSetType: string
  mailSendType: string
  userCollectionTypeFrom: string
  userCollectionTypeTo: string
  isNotOutputUser: boolean
  isOutputTelInclude: boolean
  isNotLostCollection: boolean
  isNotLostProcedure: boolean
  isOutputDetail: boolean
  isOtherDunningDoc: boolean
  isOutputDunningUser: boolean
  isNotOutputLendStop: boolean
  isOutputSchoolAge: boolean
  isOutputOrder: boolean
  outputOrderType: string
  batchType: string
}

export function BatchReminderListConditionListItemFromJSON(
  json: any
): BatchReminderListConditionListItem {
  const resp = JSON.parse(json)

  return {
    returnPlansDateFrom: exists(resp, 'return_plans_date_from')
      ? resp.return_plans_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    returnPlansDateTo: exists(resp, 'return_plans_date_to')
      ? resp.return_plans_date_to
      : dayjs().format('YYYYMMDD'),
    dunningDateFrom: exists(resp, 'dunning_date_from')
      ? resp.dunning_date_from
      : '',
    dunningDateTo: exists(resp, 'dunning_date_to') ? resp.dunning_date_to : '',
    branchCodeFrom: exists(resp, 'branch_code_from')
      ? resp.branch_code_from
      : '',
    branchCodeTo: exists(resp, 'branch_code_to') ? resp.branch_code_to : '',
    radioBranchType: exists(resp, 'radio_branch_type')
      ? resp.radio_branch_type
      : '1',
    radioUserType: exists(resp, 'radio_user_type') ? resp.radio_user_type : '1',

    userType: exists(resp, 'user_type') ? resp.user_type : '',
    update: exists(resp, 'update') ? resp.update : '2',
    isSearchBooks: exists(resp, 'is_search_books')
      ? resp.is_search_books
      : false,
    isSearchAV: exists(resp, 'is_search_av') ? resp.is_search_av : false,
    isSearchMagazine: exists(resp, 'is_search_magazine')
      ? resp.is_search_magazine
      : false,
    isEnabledHoldingBooks: exists(resp, 'is_enabled_holding_books')
      ? resp.is_enabled_holding_books
      : false,
    bookCount: exists(resp, 'book_count') ? resp.book_count : '',
    isRsvCollection: resp.is_rsv_collection,
    rsvCollectionCount: exists(resp, 'rsv_collection_count')
      ? resp.rsv_collection_count
      : '',
    reminderSetType: exists(resp, 'reminder_set_type')
      ? resp.reminder_set_type
      : '',
    mailSendType: exists(resp, 'mail_send_type') ? resp.mail_send_type : '1',
    userCollectionTypeFrom: exists(resp, 'user_collection_type_from')
      ? resp.user_collection_type_from
      : '',
    userCollectionTypeTo: exists(resp, 'user_collection_type_to')
      ? resp.user_collection_type_to
      : '',
    isNotOutputUser: exists(resp, 'is_not_output_user')
      ? resp.is_not_output_user
      : false,
    isOutputTelInclude: exists(resp, 'is_output_tel_include')
      ? resp.is_output_tel_include
      : false,
    isNotLostCollection: exists(resp, 'is_not_lost_collection')
      ? resp.is_not_lost_collection
      : false,
    isNotLostProcedure: exists(resp, 'is_not_lost_procedure')
      ? resp.is_not_lost_procedure
      : false,
    isOutputDetail: exists(resp, 'is_output_detail')
      ? resp.is_output_detail
      : false,
    isOtherDunningDoc: exists(resp, 'is_other_dunning_doc')
      ? resp.is_other_dunning_doc
      : false,
    isOutputDunningUser: exists(resp, 'is_output_dunning_user')
      ? resp.is_output_dunning_user
      : false,
    isNotOutputLendStop: exists(resp, 'is_not_output_lend_stop')
      ? resp.is_not_output_lend_stop
      : false,
    isOutputSchoolAge: exists(resp, 'is_output_school_age')
      ? resp.is_output_school_age
      : false,
    isOutputOrder: exists(resp, 'is_output_order')
      ? resp.is_output_order
      : false,
    outputOrderType: exists(resp, 'output_order_type')
      ? resp.output_order_type
      : '1',
    batchType: resp.batch_type
  }
}
